import { render, staticRenderFns } from "./BalanceChangeRequests.vue?vue&type=template&id=c307da5a&"
import script from "./BalanceChangeRequests.vue?vue&type=script&lang=js&"
export * from "./BalanceChangeRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports